
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("4zqcY"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("4zqcY", function(module, exports) {

let $353ec2b7f6713bfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $353ec2b7f6713bfa$var$load("h3ABO"),
    $353ec2b7f6713bfa$var$load("2fH0a"),
    $353ec2b7f6713bfa$var$load("OkWBV"),
    $353ec2b7f6713bfa$var$load("4jlMu"),
    $353ec2b7f6713bfa$var$load("2YffH"),
    $353ec2b7f6713bfa$var$load("2VmDq"),
    $353ec2b7f6713bfa$var$load("g7ggm"),
    $353ec2b7f6713bfa$var$load("6mHrv"),
    $353ec2b7f6713bfa$var$load("awWN9"),
    $353ec2b7f6713bfa$var$load("9CYct"),
    $353ec2b7f6713bfa$var$load("dJdZe"),
    $353ec2b7f6713bfa$var$load("lgOou"),
    $353ec2b7f6713bfa$var$load("hZtKG"),
    $353ec2b7f6713bfa$var$load("dkqvW"),
    $353ec2b7f6713bfa$var$load("lVO3w"),
    $353ec2b7f6713bfa$var$load("hyzoX"),
    $353ec2b7f6713bfa$var$load("h9Ed7"),
    $353ec2b7f6713bfa$var$load("eBRUf"),
    $353ec2b7f6713bfa$var$load("kbRvk"),
    $353ec2b7f6713bfa$var$load("tKhaz"),
    $353ec2b7f6713bfa$var$load("9Vh0G"),
    $353ec2b7f6713bfa$var$load("hBIgN"),
    $353ec2b7f6713bfa$var$load("cD6Zr"),
    $353ec2b7f6713bfa$var$load("k3jER"),
    $353ec2b7f6713bfa$var$load("9wzNh"),
    $353ec2b7f6713bfa$var$load("8YSo7"),
    $353ec2b7f6713bfa$var$load("9ldRJ"),
    $353ec2b7f6713bfa$var$load("50ame"),
    $353ec2b7f6713bfa$var$load("e7ZUf"),
    $353ec2b7f6713bfa$var$load("gL8bn"),
    $353ec2b7f6713bfa$var$load("1MlIV"),
    $353ec2b7f6713bfa$var$load("6iz6l"),
    $353ec2b7f6713bfa$var$load("4SCW2"),
    $353ec2b7f6713bfa$var$load("8bXcu"),
    $353ec2b7f6713bfa$var$load("1YiFu"),
    $353ec2b7f6713bfa$var$load("hv4mn"),
    $353ec2b7f6713bfa$var$load("Wowvf"),
    $353ec2b7f6713bfa$var$load("dek7I"),
    $353ec2b7f6713bfa$var$load("dYtBN"),
    $353ec2b7f6713bfa$var$load("kNV5Y"),
    $353ec2b7f6713bfa$var$load("6wr18"),
    $353ec2b7f6713bfa$var$load("kjZZD"),
    $353ec2b7f6713bfa$var$load("7cDV0"),
    $353ec2b7f6713bfa$var$load("ijD5W"),
    $353ec2b7f6713bfa$var$load("3JSgG"),
    $353ec2b7f6713bfa$var$load("37ldp"),
    $353ec2b7f6713bfa$var$load("ffEVr"),
    $353ec2b7f6713bfa$var$load("9AXkC"),
    $353ec2b7f6713bfa$var$load("28arV"),
    $353ec2b7f6713bfa$var$load("hhss7"),
    $353ec2b7f6713bfa$var$load("jYUNl"),
    $353ec2b7f6713bfa$var$load("foy8I"),
    $353ec2b7f6713bfa$var$load("f1Pmi"),
    $353ec2b7f6713bfa$var$load("dP7ao"),
    $353ec2b7f6713bfa$var$load("hogcU"),
    $353ec2b7f6713bfa$var$load("5vfHd"),
    $353ec2b7f6713bfa$var$load("2Stk7"),
    $353ec2b7f6713bfa$var$load("7EorR"),
    $353ec2b7f6713bfa$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.fd6c0df6.js.map
